import { render, staticRenderFns } from "./TariffComparison.vue?vue&type=template&id=0dfd589d"
import script from "./TariffComparison.vue?vue&type=script&lang=js"
export * from "./TariffComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports